/**
 * IMPORTANT: The "appCode", "command", and "ping" objects are arrays. The position of each record in the array corresponds to
 * its numeric value. DO NOT change the order of these entries.
 * "pingResponse" is a sparse array, because relatively few of the values are valid Ping Response types.
 */
export default {
    messages: {
        appCode: [
            "AC 0 – Testing",
            "AC 1 – Meter Setup / Configuration",
            "AC 2 - Reserved",
            "AC 3 – iCon UI1203 Meter Read with History",
            "AC 4 – Alarm",
            "AC 5 – Serial Number / Position Binding",
            "AC 6 – GPS Mapping",
            "AC 7 – Command",
            "AC 8 – Buddy",
            "AC 9 – Water/Gas Meter Setup / Configuration",
            "AC 10 – Water/Gas Meter Read with History  (Deprecated)",
            "AC 11 – Water/Gas Alarm",
            "AC 12 – iCon UI1203 Meter Read with Compressed History",
            "AC 13 – C&I Meter Read w/History",
            "AC 14 – C&I Tier Data",
            "AC 15 – C&I C12.19 Tunneling Read",
            "AC 16 – C&I Alarm",
            "AC 17 – Gas Setup and Configuration (Deprecated)",
            "AC 18 – Water/Gas Interval Data",
            "AC 19 – Gas Meter Read (Deprecated)",
            "AC 20 – Residential Meter Read w/ Demand",
            "AC 21 – Residential Net Meter Read with Dual History",
            "AC 22 – Extended Setup Information",
            "AC 23 – Residential Interval Data",
            "AC 24 – High Resolution Meter Read with History",
            "AC 25 – Demand History",
            "AC 26 – HHD Installation Information",
            "AC 27 – Water/Gas Meter Read w/ History",
            "AC 28 – Load Profile Meta Data",
            "AC 29 – Load Profile Block Data",
            "AC 30 – Firmware Image Check Response",
            "AC 31 – Demand History  with Reading",
            "AC 32 – Home LAN",
            "AC 33 – Extended Residential Interval Data",
            "AC 34 – Cooper",
            "AC 35 – Zigbee",
            "AC 36 – Reserved",
            "AC 37 – Gas Meter Setup and Configuration",
            "AC 38 – Reserved",
            "AC 39 – Reserved",
            "AC 40 – Single Parameter Meter Read",
            "AC 41 – Dual Parameter Meter Read",
            "AC 42 – Single Parameter Meter Read w/Demand",
            "AC 43 – Dual Parameter Meter Read w/Demand",
            "AC 44 – Alarm  (StratusIQ/Stratus/iConA)",
            "AC 45 – Advanced Alarm  (StratusIQ/Stratus/iConA)",
            "AC 46 – iConA Demand History",
            "AC 47 – Secondary Group Address Vector",
            "AC 48 – Generic Ping Response",
            "AC 49 – iConA TOU Billing Data",
            "AC 50 – iConA Load Profile Data",
            "AC 51 – FNP Setup/Configuration",
            "AC 52 – Poletop Supervisory",
            "AC 53 – Priority Mode Alarm",
            "AC 54 – Priority Mode Read",
            "AC 55 – C&I High Res Read with History Data",
            "AC 56 – Time Adjustment Log",
            "AC 57 – Scratch Pad Image Check Response",
            "AC 58 – Cooper Serial",
            "AC 59 – MetPod Supervisory",
            "AC 60 – MetPod Alarm",
            "AC 61 – MetPod Demand Record",
            "AC 62 – Zigbee Pass-Through To Network",
            "AC 63 – Zigbee Multi-Packet Pass-Through To Network",
            "AC 64 – Priority Mode C&I High Res Read",
            "AC 65 – Priority Mode C&I Read",
            "AC 66 – Smart Grid Response",
            "AC 67 – C&I Priority Mode Alarm",
            "AC 68 – C&I Load Profile Extended Block Data",
            "AC 69 – Priority Short Alarm",
            "AC 70 – NA2W Wb/Db Read",
            "AC 71 – Serial Number",
            "AC 72 – NA2W Meters Found",
            "AC 73 – NA2W Ep Setup Audit",
            "AC 74 – NA2W Install Audit",
            "AC 75 – NA2W Channel Setup Audit",
            "AC 76 – NA2W Ep Capabilities",
            "AC 77 – iConA Weekly Alarm",
            "AC 78 – NA2W Interval Data Response",
            "AC 79 – NA2W Firmware Image Check Response",
            "AC 80 – NA2W Statistics Reporting",
            "AC 81 – iCon Priority Mode Clean-Up Read",
            "AC 82 – iCon Priority Short Real-Time Alarm",
            "AC 83 – FlexIP",
            "AC 84 – W&G Smart Meter Alarm",
            "AC 85 – NA2W Channel Setup 2 Audit",
            "AC 86 – NA2W Binding/Configuration",
            "AC 87 – Multi-Packet Transfer (MPT)",
            "AC 88 – HAN 2.0 Single Response",
            "AC 89 – HAN 2.0 Multi-Response",
            "AC 90 – NA2W Device Status",
            "AC 91 – NA2W Device Operation Result",
            "AC 92 – LP ESM",
            "AC 93 – Extended Messages",
            "AC 94 – NA2W Attribute String",
            "AC 95 – Distribution Automation Type 1",
            "AC 96 – Distribution Automation Type 2",
            "AC 97 – Distribution Automation Type 3",
            "AC 98 – Distribution Automation Type 4",
            "AC 99 – Distribution Automation Type 5",
            "AC 100 – Prepay",
            "AC 101 – NA2W Data Report",
            "AC 102 – Commshub",
            "AC 103 – Tunneled Register Response",
            "AC 104 – UI-1236 Response",
            "AC 105 – NA2W Smart Alarm Configuration Audit",
            "AC 106 – NA2W Meter Information",
            "AC 107 – NA2W Fixed Base Configuration",
            "AC 108 – NA2W Read with History",
            "AC 109 - Reserved",
            "AC 110 - Reserved",
            "AC 111 - Reserved",
            "AC 112 - Reserved",
            "AC 113 - Reserved",
            "AC 114 - Reserved",
            "AC 115 - Reserved",
            "AC 116 - Reserved",
            "AC 117 - Reserved",
            "AC 118 - Reserved",
            "AC 119 - Reserved",
            "AC 120 - Reserved",
            "AC 121 - Reserved",
            "AC 122 - Reserved",
            "AC 123 - Reserved",
            "AC 124 - Reserved",
            "AC 125 - Reserved",
            "AC 126 – Line Powered Extended AppCodes",
            "AC 127 – NA2W Extended AppCodes",
            "AC 128 – FNv2 Uplink Endpoint Ack/Nak",
            "AC 129 – FNv2 Securitiy Summary Reply",
            "AC 130 – FNv2 Setup / Configuration",
            "AC 131 – FNv2 File Transfer Status",
            "AC 132 - Reserved",
            "AC 133 - Reserved",
            "AC 134 - Reserved",
            "AC 135 - Reserved",
            "AC 136 – FNv2 Test Msg Reply",
        ],
        command: [
            "Cmd 0 – Command Acknowledge",
            "Cmd 1 – Static Setup",
            "Cmd 2 – Set TCXO Correction",
            "Cmd 3 – Set Latitude and Longitude",
            "Cmd 4 – Set Voltage Quality Settings",
            "Cmd 5 – Set Epoch Time",
            "Cmd 6 – Load Shed",
            "Cmd 7 – Demand Read/Drive By Read",
            "Cmd 8 – Ping",
            "Cmd 9 – Set FlexNet ID",
            "Cmd 10 – Set Customer Id",
            "Cmd 11 – Set Encryption Key",
            "Cmd 12 – Set Preferred Buddy ID",
            "Cmd 13 – Set Customer Serial Number",
            "Cmd 14 – Set Display Text",
            "Cmd 15 – C&I Read C12.19 Data",
            "Cmd 16 – C&I Write C12.19 Data",
            "Cmd 17 – Demand Reset",
            "Cmd 18 – A/D Calibration",
            "Cmd 19 – Set Group Address",
            "Cmd 20 – Delay Supervisory Transmissions",
            "Cmd 21 – Home LAN",
            "Cmd 22 – Interval Data Configuration",
            "Cmd 23 – Interval Data Clear",
            "Cmd 24 – ZigBee Command",
            "Cmd 25 – Firmware Maintenance Command",
            "Cmd 26 – Firmware Block Load Command",
            "Cmd 27 – Reset FlexNet Module",
            "Cmd 28 – Set Meter Logon Info",
            "Cmd 29 – Set Secondary Group Address Vector",
            "Cmd 30 – Set AES Encryption Key",
            "Cmd 31 – Set FlexNet Read/Write Transmit Rates",
            "Cmd 32 – Set iConA Customer Load Profile Channel",
            "Cmd 33 – Set Electric Meter History Resolution",
            "Cmd 34 – Set Advanced Voltage Quality",
            "Cmd 35 – Demand Enable/Master Configuration",
            "Cmd 36 – TOU Enable/Master Configuration",
            "Cmd 37 – Configure Meter Parameters/Net Format",
            "Cmd 38 – Configure iCon Reverse Power/Stop on Errors/Reset",
            "Cmd 39 – Configure iCon CT/PT Multipliers",
            "Cmd 40 – Configure iCon LCD Format",
            "Cmd 41 – Configure iCon LCD Display List",
            "Cmd 42 – Configure TOU Season A Start Date / Tier Schedule",
            "Cmd 43 – Configure TOU Season and DST Dates",
            "Cmd 44 – Configure TOU Even Year Holidays",
            "Cmd 45 – Configure TOU Odd Year Holidays",
            "Cmd 46 – Configure TOU Schedule Map",
            "Cmd 47 – Configure TOU / Daily Self Read Auto-Push Options",
            "Cmd 48 – TOU Critical Peak Override",
            "Cmd 49 – Configure Demand Main/Sub-Intervals",
            "Cmd 50 – Reset TOU",
            "Cmd 51 – iCon Meter Reset",
            "Cmd 52 – FlexNet Advanced Setup",
            "Cmd 53 – Configure Load Limiting",
            "Cmd 54 – Set Next AES Encryption Key",
            "Cmd 55 – Set Fixed Time Zone",
            "Cmd 56 – Set AES Encryption Key Base",
            "Cmd 57 – Set Time Adjustment Threshold",
            "Cmd 58 – Configure iCon Self Read Hour",
            "Cmd 59 – Scratch Pad Block Command",
            "Cmd 60 – Scratch Pad Op Command",
            "Cmd 61 – Clear iConA Warnings and Errors",
            "Cmd 62 – Cooper Serial Command",
            "Cmd 63 – Configure iConA Remote Disconnect",
            "Cmd 64 – Configure FNP",
            "Cmd 65 – Generic MetPod Command",
            "Cmd 66 – ZigBee Network Pass-through",
            "Cmd 67 – ZigBee Multi-Packet Network Pass-through",
            "Cmd 68 – Set iConA Meter Registers",
            "Cmd 69 – Flush Buddy Queue",
            "Cmd 70 – C&I Factory Configuration",
            "Cmd 71 – Configure TOU \"Even\" Year Holidays",
            "Cmd 72 – Configure TOU \"Odd\" Year Holidays",
            "Cmd 73 – Set AES Encryption Key",
            "Cmd 74 – Suspend AES Encryption",
            "Cmd 75 – Set Tx/Rx Frequencies",
            "Cmd 76 – Force Encrypted Response",
            "Cmd 77 – Configure Group Command Options",
            "Cmd 78 – Gang ACK",
            "Cmd 79 – WB/DB Silencing ACK",
            "Cmd 80 – NA2W Install Initiation",
            "Cmd 81 – Encapsulated Serial Command",
            "Cmd 82 – Multi TX with LAT Command",
            "Cmd 83 – Bind Meter Command",
            "Cmd 84 – NA2W EP Setup",
            "Cmd 85 – NA2W Channel Setup",
            "Cmd 86 – NA2W Activate",
            "Cmd 87 – Buddy Throttle Configuration",
            "Cmd 88 – Multi-ID Ping",
            "Cmd 89 – NA2W EP Setup 2",
            "Cmd 90 – Switch Top-Level State",
            "Cmd 91 – NA2W Channel Setup 2",
            "Cmd 92 – NA2W Device Operation Request",
            "Cmd 93 – Set AES Encryption Control Bits",
            "Cmd 94 – Measure AC Line Phase",
            "Cmd 95 – FlexNet Tuning",
            "Cmd 96 – Multi-Packet Transfer (MPT)",
            "Cmd 97 – iConAS Extended Commands",
            "Cmd 98 – HAN 2.0 Single Packet",
            "Cmd 99 – HAN 2.0 Multi-Packet",
            "Cmd 100 – NA2W Set Attribute String",
            "Cmd 101 – LP ESM Configuration",
            "Cmd 102 – Distribution Automation Type 1",
            "Cmd 103 – Distribution Automation Type 2",
            "Cmd 104 – Distribution Automation Type 3",
            "Cmd 105 – Distribution Automation Type 4",
            "Cmd 106 – Distribution Automation Type 5",
            "Cmd 107 – FlexIP Datagram",
            "Cmd 108 – Schedule a FlexNet Command",
            "Cmd 109 – PrePay Command",
            "Cmd 110 – Internet Protocol Interface Configuration Command",
            "Cmd 111 – Tunneled Register Command",
            "Cmd 112 – Set SensusRF Encryption Key",
            "Cmd 113 – Tether Free X Parameter Reset",
            "Cmd 114 – UI-1236 Command",
            "Cmd 115 – NA2W Smart Alarm Configuration",
            "Cmd 116 – NA2W Smart Alarm Clear",
            "Cmd 117 – Set iConA Communication Mode",
            "Cmd 118 – Configure iConA Chatter Detection",
            "Cmd 119 – Acknowledgement",
            "Cmd 120 – Reserved",
            "Cmd 121 – Unlicensed FlexNet Beacon",
            "Cmd 122 – FNv2 Setup",
            "Cmd 123 – NA2W FNv2 Setup",
            "Cmd 124 – Reserved",
            "Cmd 125 – Reserved",
            "Cmd 126 – Line Powered Extended Commands",
            "Cmd 127 – NA2W Extended Commands",
            "Cmd 128 – FNv2 Downlink ACK/NAK",
            "Cmd 129 – FNv2 Tuning",
            "Cmd 130 – Write EC Cert",
            "Cmd 131 – ECDH Handshake",
            "Cmd 132 – Suspend Signatures",
            "Cmd 133 – Fragment Control",
            "Cmd 134 – Set Secret Key",
            "Cmd 135 – FNv2 Set Epoch",
            "Cmd 136 – FNv2 Tetst",
            "Cmd 137 – FNv2 Load Shed",
            "Cmd 138 – File Transfer - Control",
            "Cmd 139 – File Transfer - Block",
        ],
        ping: [
            "Ping 0 - Normal Ping",
            "Ping 1 - Configuration Ping",
            "Ping 2 - Demand Read Ping",
            "Ping 3 - Handheld mPass Binding Ping - Buddy Allowed",
            "Ping 4 - Handheld mPass Binding Ping - Buddy Disabled",
            "Ping 5 - Alarm Ping",
            "Ping 6 - Handheld mPass Alarm Ping - Buddy Disabled",
            "Ping 7 - Handheld mPass Demand Read Ping - Buddy Disabled",
            "Ping 8 - Meter Reading",
            "Ping 9 - Tier Data",
            "Ping 10 - Demand Read Ping Only",
            "Ping 11 - Single Tier",
            "Ping 12 - Water Interval Data",
            "Ping 13 - Water Interval Data",
            "Ping 14 - Extended Setup",
            "Ping 15 - Setup",
            "Ping 16 - Binding",
            "Ping 17 - Electric Interval Data",
            "Ping 18 - Electric Interval Data from Address",
            "Ping 19 - Electric Interval Data Clear",
            "Ping 20 - Single Tier Message w/ Read",
            "Ping 21 - Demand History",
            "Ping 22 - HHD Installation Information",
            "Ping 23 - Reserved",
            "Ping 24 - Reserved",
            "Ping 25 - Reserved",
            "Ping 26 - Home LAN Ping",
            "Ping 27 - iConA Enhanced Alarm",
            "Ping 28 - Secondary Group Address Vector",
            "Ping 29 - iCon Serial Number",
            "Ping 30 - iCon Style Number",
            "Ping 31 - Icon Meter Form and Voltage",
            "Ping 32 - iCon CT/ PT Multipliers",
            "Ping 33 - iCon Reverse Power / Error / Reset Settings",
            "Ping 34 - iCon LCD Format / Current Display List",
            "Ping 35 - Demand Enable Status/ Interval Configuration",
            "Ping 36 - TOU Enable Status/ Tier and Season Configuration",
            "Ping 37 - TOU Current Year Holidays",
            "Ping 38 - TOU Next Year Holidays",
            "Ping 39 - Click History",
            "Ping 40 - Load Limit Status / Threshold",
            "Ping 41 - Advanced Voltage Quality Settings",
            "Ping 42 - TOU Auto-Push Options",
            "Ping 43 - iConA Current TOU Tier Data",
            "Ping 44 - iConA Current TOU Dual Tier Ping (No Meter Read)",
            "Ping 45 - iConA Current TOU Dual Tier Ping (Meter Read)",
            "Ping 46 - Reserved",
            "Ping 47 - Reserved",
            "Ping 48 - Reserved",
            "Ping 49 - iConA Load Profile Data",
            "Ping 50 - FlexNet Advanced Setup",
            "Ping 51 - C&I High Res Read w/Pulse Data",
            "Ping 52 - Read Time Adjustment Log",
            "Ping 53 - Who's Your Buddy?",
            "Ping 54 - iConA Daily Read",
            "Ping 55 - TOU Day Type",
            "Ping 56 - iConA Factory Configuration",
            "Ping 57 - iConA Send TOU Rate and Current Time",
            "Ping 58 - Combined Extended Setup and Bind",
            "Ping 59 - Send AES Key Hash",
            "Ping 60 - Load Profile Multi-block",
            "Ping 61 - Load Profile Single Block Segment",
            "Ping 62 - Request NA2W Information",
            "Ping 63 - Request all FlexNet IDs",
            "Ping 64 - Request both Serial Numbers",
            "Ping 65 - NA2W Configuration Ping.",
            "Ping 66 - iConA Service Quality",
            "Ping 67 - Buddy Throttle Configuration",
            "Ping 68 - iConA Weekly Alarm",
            "Ping 69 - Request NA2W WB/DB Interval Data",
            "Ping 70 - NA2W EP Setup Audit",
            "Ping 71 - NA2W Install Audit",
            "Ping 72 - NA2W Channel Setup Audit",
            "Ping 73 - W&G Smart Meter Alarm Ping",
            "Ping 74 - NA2W Status Request",
            "Ping 75 - AES Last Command Info",
            "Ping 76 - NA2W Channel Setup 2 Audit",
            "Ping 77 - NA2W Schedule Ping",
            "Ping 78 - LP ESM Configuration",
            "Ping 79 - LP ESM Metadata",
            "Ping 80 - Get Calibration Values",
            "Ping 81 - iConAS Extended Queries",
            "Ping 82 - LP ESM Backfill Request",
            "Ping 83 - NA2W Attribute String",
            "Ping 84 - Read Scheduled Command Table",
            "Ping 85 - Request Board ID Info",
            "Ping 86 - Universal FW Version",
            "Ping 87 - Internet Protocol Interface Configuration",
            "Ping 88 - Internet Protocol Interface List",
            "Ping 89 - Load Profile Scalar Divisor",
            "Ping 90 - ESM Status",
            "Ping 91 - Configuration Change Log",
            "Ping 92 - iConA Factory Configuration2",
            "Ping 93 - NA2W Data Report",
            "Ping 94 - NA2W Meter Information",
            "Ping 95 - NA2W Fixed Base Configuration",
            "Ping 96 - NA2W Smart Alarm Configuration Audit",
            "Ping 97 - Water Reading String",
            "Ping 98 - iConA Communication Mode",
            "Ping 99 - iConA Chatter Detection",
            "Ping 100 - NA2W Setup Dump Ping",
            "Ping 101 - Security Read",
            "Ping 102 - Load Shed Status",
            "Ping 103 - Extended Query",
            "Ping 104 - Identification/Comm state",
        ],
        pingResponse: {
            14:  "PR 14",
            29:  "PR 29 - Serial Number",
            30:  "PR 30 - Style Number",
            31:  "PR 31 - Meter Form and Voltage",
            32:  "PR 32 - CT / PT Multipliers",
            33:  "PR 33 - iCon Reverse Power / Error / Reset Status",
            34:  "PR 34 - LCD Format / Current Display List",
            35:  "PR 35 - Demand Enable Status / Interval Configuration",
            36:  "PR 36 - TOU Configuration",
            37:  "PR 37 - TOU \"Even\" Year Holidays",
            38:  "PR 38 - TOU \"Odd\" Year Holidays",
            39:  "PR 39 - Momentary Outage History",
            40:  "PR 40 - Load Limit Status / Threshold",
            41:  "PR 41 - Advanced Voltage Quality Settings",
            42:  "PR 42 - TOU/DSR Auto-Push Options",
            46:  "PR 46 - Local Time",
            50:  "PR 50 - FlexNet Advanced Setup",
            54:  "PR 54 - iCon Self-Read Data w/ Peak Demand History",
            55:  "PR 55 - TOU Day Type",
            56:  "PR 56 - iConA Factory Configuration",
            58:  "PR 58 - Combined Extended Setup and Bind",
            59:  "PR 59 - AES Key Hash",
            66:  "PR 66 - Service Quality",
            67:  "PR 67 - Buddy Throttle Configuration",
            75:  "PR 75 - AES Last Command Info",
            77:  "PR 77 - NA2W Schedule",
            78:  "PR 78 - LP ESM Configuration",
            79:  "PR 79 - LP ESM Metadata",
            80:  "PR 80 - NA2W Calibration Data",
            84:  "PR 84 - Read Scheduled Command Table Response",
            85:  "PR 85 - Request Board ID Info Response",
            86:  "PR 86 - Universal FW Version",
            87:  "PR 87 - Internet Protocol Interface Configuration Response",
            88:  "PR 88 - Internet Protocol Interface List Response",
            89:  "PR 89 - Load Profile Scalar Divisor List",
            90:  "PR 90 - ESM Status",
            91:  "PR 91 - Sensus Configuration Change Log",
            92:  "PR 92 - Factory Configuration 2",
            97:  "PR 97 - Water Reading String Response",
            98:  "PR 98 - iConA Communication Mode",
            99:  "PR 99 - iConA Chatter Detection",
            104: "PR 104 - Meter Identification, Communication State, and Status Query",
        }
    },
    arqivaMsgs: {
        1: "0x01 - Static Setup",
        2: "0x02 - Test",
        3: "0x03 - Lat/Lng Command",
        4: "0x04 - Enable Transmitter",
        5: "0x05 - Set Epoch Time",
        6: "0x06 - Set Routing Identifier",
        8: "0x08 - Generic Ping Command",
        16: "0x10 - L2ACK Report",
        18: "0x12 - Full Tower Signal Strength Report",
        19: "0x13 - Full ORD Signal Strength Report",
        22: "0x16 - Request To Send (RTS)",
        23: "0x17 - MPT Downlink",
        24: "0x18 - MPT Uplink",
        25: "0x19 - Rotate AES Key",
        26: "0x1A - Suspend Encryption",
        27: "0x1B - Force Encyption Response",
        29: "0x1D - Set Groups",
        30: "0x1E - Set Tamper Interval",
        32: "0x20 - Beacon",
        33: "0x21 - Buddy Message Acknowledged",
        39: "0x27 - MPT Downlink (New)",
        40: "0x28 - MPT Uplink (New)",
        46: "0x2E - Local Time",
        49: "0x31 - FWDL Command",
        50: "0x32 - FWDL Command Response",
        51: "0x33 - FWDL Load Block",
        59: "0x3B - AES Key Binding",
        75: "0x4B - Last Command Info",
        86: "0x56 - Universal Firmware Version",
        110: "0x6E - IP Interface",
        135: "0x87 - IP Interface Configuration",
        194: "0xC2 - IP Downlink Datagram",
        195: "0xC3 - IP Uplink Datagram",
        196: "0xC4 - IP Downlink Trace Path",
        197: "0xC5 - IP Uplink Trace Path",
        198: "0xC6 - DLMS Datagram",
        200: "0xC8 - OTF Block Transfer Downlink",
        201: "0xC9 - OTF Block Transfer Uplink",
        202: "0xCA - OTF Block Resend Downlink",
        203: "0xCB - OTF Block Resend Uplink",
        204: "0xCC - OTF Control Message Downlink",
        205: "0xCD - OTF Control Message Uplink",
        240: "0xF0 - Alarms",
        242: "0xF2 - Location GPS Waypoint",
        255: "0xFF - Unknown"
    }
}
